import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { reduxForm, Field } from 'redux-form';
import { Grid } from './../../../themes/default';
import { Section, Content, Main, Buttons, FormContent, FormActions } from './../../../components/includes/container';
import { Loading } from './../../../components/includes/loading';
import { ToolbarPrimary } from './../../../components/includes/toolbar';
import { BreadcrumbItem } from './../../../components/includes/breadcrumb';
import { Ttolbar } from './../../../components/includes/ui/table';
import { InputTextField, SelectField, OptionField } from './../../../components/includes/ui/input';
import { Btn } from './../../../components/includes/ui';
import { AlertService } from './../../../services';

import VALIDATION from './../../../config/validation';

const validate = values => {

  const errors = {}

  if (values.status === '-1') {
    errors.status = VALIDATION.required;
  }

  if (values.type === '-1') {
    errors.type = VALIDATION.required;
  }

  if (!values.name) {
    errors.name = VALIDATION.required;
  }else if(values.name.length > 255){
    errors.name = 'El tamaño máximo es de 255 caracteres.';
  }

  if (!values.description) {
    errors.description = VALIDATION.required;
  }else if(values.description.length > 255){
    errors.description = 'El tamaño máximo es de 255 caracteres.';
  }

  return errors

};

class AlertUpdate extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      id: null,
      loading: false,
      sending: false
    };
  }

  componentDidMount(){

    this._Find(this.props.match.params.id);

  }

  /*
  ** @Service
  ** @Description: Find
  */

  _Find = (id) => {

    AlertService.find(id).then((response) => {

      // @State
      this.setState({ loading: true, id: id });

      // @Dispatch
      this.props.Update(response);

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: error });

    });

  }

  /*
  ** @Service
  ** @Description: Update
  */

  _Update = (values) => {

    // @Loading
    this.setState({ loading: false });

    // @Service
    AlertService.update(this.state.id, values).then((response) => {

      /**
      * @Service find all by page
      */
      this.props.history.push('/alerts');

      /**
      * @Dispatch for alert success message
      */
      this.props.AlertShow({ open: true, variant: 'success', message: `Exitio, el alerta fue editado.` });

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: error.data.message });

    });

  }

  /*
  ** @Event
  ** @Description: Submit button
  */

  handleSubmitForm = (values) => {
    this._Update(values);
  }

  render() {

    const { loading, sending } = this.state;
    const { handleSubmit, invalid } = this.props;

    return (
      <Section>
        <ToolbarPrimary title="Alertas"/>
        <BreadcrumbItem to='/alerts'>Alertas</BreadcrumbItem>
        <BreadcrumbItem to='/alerts/update'>Crear</BreadcrumbItem>
        <Content>

          <Main>

            { loading ? (

              <form noValidate autoComplete="off" onSubmit={ handleSubmit(this.handleSubmitForm) }>

                <Ttolbar title="Edición de alerta"/>

                <FormContent enabledActions>

                  <Grid container spacing={24}>

                    <Grid item lg={4} md={4} sm={12} xs={12}>
                      <Field
                          name="name"
                          component={ InputTextField }
                          label="Nombre"
                          type="text"
                          required
                      />
                    </Grid>

                    <Grid item lg={4} md={4} sm={12} xs={12}>
                      <Field
                          name="type"
                          component={ SelectField }
                          label="Tipo" required>
                            <OptionField key="-1" value="-1">Seleccionar...</OptionField>
                            <OptionField key="default" value="default">Default</OptionField>
                            <OptionField key="primary" value="primary">Cyan</OptionField>
                            <OptionField key="success" value="success">Green</OptionField>
                            <OptionField key="error" value="error">Red</OptionField>
                      </Field>
                    </Grid>

                    <Grid item lg={4} md={4} sm={12} xs={12}>
                      <Field
                          name="status"
                          component={ SelectField }
                          label="Estado" required>
                            <OptionField key="-1" value="-1">Seleccionar...</OptionField>
                            <OptionField key="true" value="true">Activo</OptionField>
                            <OptionField key="false" value="false">Bloqueado</OptionField>
                      </Field>
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Field
                          name="description"
                          component={ InputTextField }
                          label="Texto"
                          type="text"
                          required
                      />
                    </Grid>

                  </Grid>

                </FormContent>

                <FormActions>
                  <Grid container>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                      <Buttons>
                        <Btn aria-label="Volver" icon="back" color="secondary" component={ NavLink } to="/alerts">
                          Volver
                        </Btn>
                      </Buttons>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                      <Buttons align="right">
                        <Btn aria-label="Guardar alerta" icon="add" color="success" type="submit" disabled={ invalid } loading={ sending }>
                          Guardar alerta
                        </Btn>
                      </Buttons>
                    </Grid>
                  </Grid>
                </FormActions>

              </form>

            ) : (
              <Loading variant="primary"/>
            )}

          </Main>

        </Content>
      </Section>
    )
  }
}

AlertUpdate = reduxForm({
  form: 'AlertUpdate',
  validate,
  enableReinitialize: true
})(AlertUpdate);

const mapStateToProps = (state) => {
  return {
    Alert: state.Alert,
    AlertUpdate: state.AlertUpdate
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    },
    Update: (data) => {
      dispatch({
        type: 'ALERT_UPDATE',
        data: data
      });
    }
  }
}

AlertUpdate = connect(
  state => ({
    initialValues: {
      name: state.AlertUpdate.name,
      status: state.AlertUpdate.status,
      type: state.AlertUpdate.type,
      description: state.AlertUpdate.description,
    }
  })
)(AlertUpdate);

export default connect(mapStateToProps, mapDispatchToProps)(AlertUpdate);
